import { render, staticRenderFns } from "./ButtonSwitcher.vue?vue&type=template&id=f6d2d4e4&scoped=true"
import script from "./ButtonSwitcher.vue?vue&type=script&lang=js"
export * from "./ButtonSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ButtonSwitcher.vue?vue&type=style&index=0&id=f6d2d4e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d2d4e4",
  null
  
)

export default component.exports